let eventProducerUrl = "/ep-horizon/api/v1/et";
const setEventProducerUrl = (url) => {
  eventProducerUrl = url;
};
export {
  eventProducerUrl,
  setEventProducerUrl
};
